import styled from "styled-components";
import metaMaskImg from "./assets/images/metamask.svg";
import walletConnectImg from "./assets/images/walletconnect.svg";
import { toast } from "react-toastify";
import { config } from "./environment";

export const Button = styled.button`
  border: 3px solid #333;
  font-weight: 900;
  padding: 0 10px;
  height: 46px;
  margin: 5px;
  cursor: pointer;
  user-select: none;

  &.buy-credit{
    @media screen and (min-width: 1024px) and (max-width: 1220px) {
    font-size: 12px;
  }
  }
  &.bottom-btn {
    background: #fed743;
    display: inline-block;
    position: relative;
    text-align: center;
    font-size: 18px;
    text-decoration: none;
    border: none;
    padding: 0 20px;
    height: 46px;
    &::after {
      left: -2px;
      top: 0;
      border-left: 3px black solid;
      border-right: 3px black solid;
      content: "";
      position: absolute;
      width: calc(100% - 2px);
      height: 100%;
      box-sizing: content-box;
    }
    &::before {
      top: -2px;
      left: 0;
      border-top: 3px black solid;
      border-bottom: 3px black solid;
      content: "";
      position: absolute;
      width: 100%;
      height: calc(100% - 2px);
      box-sizing: content-box;
    }
    @media screen and (max-width: 577px) {
      font-size: 13px;
    }
  }
`;
export const LinkButton = styled.a`
  border: 3px solid #333;
  font-weight: 900;
  padding: 0 10px;
  height: 40px;
  margin: 5px;
  font-size: 13px;
  line-height: 13px;
  cursor: pointer;
  text-decoration: none;
  color: black;
  background-color: white;
  display: flex;
  align-items: center;
  @media screen and (min-width: 1024px) and (max-width: 1220px) {
    font-size: 12px;
  }
`
export const H1 = styled.h1`
  font-weight: 900;
  &.connect-wallet {
    color: white;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    margin: 40px 0;
  }
  &.super-doge-background-title{
    font-size:40px !important;
    line-height: 45px !important;
    margin: 0 !important;
  }
  &.rocket-doge-background-title{
    font-size:43px !important;
    line-height: 45px !important;
    font-weight: 400 !important;
    margin: 0 !important;
  }
  &.to-the-moon-background-title{
    margin: 0 !important;
  }
  @media screen and (max-width: 1240px) {
    font-size: 26px;
    &.super-doge-background-title{
     font-size:33px !important;
     line-height: 35px !important;
    }
    &.rocket-doge-background-title{
      font-size:35px !important;
      line-height: 35px !important;
    }
  }
  @media screen and (max-width: 1024px) {
    font-size: 22px;
    &.super-doge-background-title{
     font-size:27px !important;
     line-height: 32px !important;
    }
    &.rocket-doge-background-title{
      font-size:27px !important;
      line-height: 32px !important;
    }
  }
  @media screen and (max-width: 768px) {
    &.super-doge-background-title{
     font-size:30px !important;
     line-height: 34px !important;
    }
  }
  @media screen and (max-width: 577px) {
    font-size: 16px;
    &.connect-wallet {
      margin: 20px 0 0 0;
    }
    &.super-doge-background-title{
     font-size:24px !important;
     line-height: 33px !important;
    }
    &.rocket-doge-background-title{
      font-size:24px !important;
      line-height: 30px !important;
    }
  }
  @media screen and (max-width: 450px) {
    &.super-doge-background-title{
     font-size:21px !important;
     line-height: 25px !important;
    }
  }
`;

export const metamask = "metamask";
export const coinbase = "coinbase";
export const walletconnect = "walletconnect";
export const ImageUrl = config.s3BaseUrl;

export const walletOption = [
  {
    title: "metamask",
    key: metamask,
    image: metaMaskImg,
    subtext: "",
    isMobileVisible: false,
  },
  // {
  //   title: "Coinbase Wallet",
  //   key: coinbase,
  //   image: coinbaseImg,
  //   subtext: "",
  //   isMobileVisible: false
  // },
  {
    title: "wallet_connect",
    key: walletconnect,
    image: walletConnectImg,
    subtext: "",
    isMobileVisible: true,
  },
];

export const isMobileDevice = () => {
  return "ontouchstart" in window || "onmsgesturechange" in window;
};

export function activateInjectedProvider(providerName) {
  const { ethereum } = window;
  if (!ethereum?.providers) {
    return undefined;
  }
  let provider;
  switch (providerName) {
    case "CoinBase":
      provider = ethereum.providers.find(
        ({ isCoinbaseWallet }) => isCoinbaseWallet
      );
      break;
    case "MetaMask":
      provider = ethereum.providers.find(({ isMetaMask }) => isMetaMask);
      break;
    default:
      break;
  }
  if (provider) {
    ethereum.setSelectedProvider(provider);
  }
}

export const creditsPlans = [
  {
    arcadeCredits: 10,
    tamaRequired: 100,
    isActive: true,
  },
  {
    arcadeCredits: 25,
    tamaRequired: 250,
    isActive: false,
  },
  {
    arcadeCredits: 50,
    tamaRequired: 500,
    isActive: true,
  },
  {
    arcadeCredits: 100,
    tamaRequired: 900,
    isActive: false,
  },
  {
    arcadeCredits: 500,
    tamaRequired: 4000,
    isActive: true,
  },
  {
    arcadeCredits: 1000,
    tamaRequired: 7500,
    isActive: false,
  },
  {
    arcadeCredits: 5000,
    tamaRequired: 30000,
    isActive: true,
  },
  {
    arcadeCredits: 10000,
    tamaRequired: 50000,
    isActive: false,
  },
];

export const notify = (msg, type) => toast[type](msg);

export const translateNum = (num) => {
  if (num.toString().length > 4) {
    return num.toLocaleString();
  } else {
    return num;
  }
};

export const options = [{ name: "english", key: "en" }];

const Games = [
  { name: "super-doge" },
  { name: "to-the-moon" },
  { name: "rocket-doge" },
];

export const IsValidGame = (game) => {
  const validGame = Games.find((g) => g.name === game);
  if(validGame) {
    return true
  }else{
    return false;
  }
};

export const HeaderLinks = [
  { name: "home", link: "https://tamadoge.io/", isList: false },
  { name: "about", link: "https://tamadoge.io/#about", isList: false },
  {
    name: "product",
    link: false,
    isList: true,
    list: [
      { name: "nfts", link: "https://tamadoge.io/nfts/" },
      { name: "tokens", link: "https://tamadoge.io/tokens/" },
    ],
  },
  {
    name: "how_to",
    link: false,
    isList: true,
    list: [
      { name: "buy_tokens", link: "https://tamadoge.io/tokens/" },
      { name: "buy_nft", link: "https://tamadoge.io/nfts/#how-to" },
      { name: "buy_with_fiat", link: "https://tamadoge.io/buy/" },
    ],
  },
  {
    name: "news",
    link: false,
    isList: true,
    list: [
      { name: "press", link: "https://tamadoge.io/press/" },
      { name: "blog", link: "https://medium.com/@TAMADOGE" },
    ],
  },
  { name: "merch", link: "https://merch.tamadoge.io/", isList: false },
];